<template>
    <div class="position-relative">
        <div class="row">
            <div class="col-12  min-height-400">
                <!-- slide 1 -->
                <div v-if="this.currentSlide == 0">
                    <h2 class="">(1/3) {{ $t('accountConfig.welcome') }}</h2>
                    <p class="large-text">{{ $t('accountConfig.thankYou') }}: </p>
                    <locale-switcher />
                    </div>
                <!-- slide 2 -->
                <div v-if="this.currentSlide == 1">
                    <h2 class="">(2/3) {{ $t('accountConfig.initialStatus') }} </h2>
                    <!--<p class="font-weight-bold">Please select what the status of new aprons should be.</p>-->

                    <div class="p-3 mb-4  rounded  position-relative">
                        
                        <div class="">{{ $t('accountConfig.initialStatusQuestion') }}</div>
                    </div>

                    <div >
                        <navigation-button class="d-inline-block mr-4" mode="custom" :allow-press="true" :text="$t('general.no')" @button-clicked="localConfig.hospitalPreferences.initialStatus=1;currentSlide++"></navigation-button>
                        <navigation-button class="d-inline-block " mode="custom" :allow-press="true" :text="$t('general.yes')" @button-clicked="localConfig.hospitalPreferences.initialStatus=2;currentSlide++"></navigation-button>
                    </div>

                </div>

                <!-- slide 3 -->
                <div v-if="this.currentSlide == 2">
                    <h2 class=""> (3/3) {{ $t('accountConfig.tolerances') }} </h2>
                    <p class="font-weight-bold">{{ $t('accountConfig.toleranceInstruction') }}</p>
                    <div class="p-3 bg-light rounded  position-relative">
                        <b-icon-info-circle-fill class="color-blue position-absolute icon-message" />
                        <div class="pl-5">
                            {{ $t('accountConfig.toleranceInfoMessage') }}
                        </div>
                    </div>

                    <Questionnaire v-model="localConfig.tolerance.limProtection"  :question-title="$t('accountConfig.protectiveQualities')"></Questionnaire>
                    <Questionnaire v-model="localConfig.tolerance.limHygiene" :question-title="$t('reportOverview.hygiene')"></Questionnaire>
                    <Questionnaire v-model="localConfig.tolerance.limFasteners" :question-title="$t('accountConfig.conditionFasteners')"></Questionnaire>
                </div>
            </div>
        </div>

        <div class="row border-top pt-4">
            <div class="col-4">
                <navigation-button v-if="currentSlide > 1" mode="back" :allow-press="true" @button-clicked="currentSlide--"></navigation-button>
            </div>
            <div class="col-4 text-center">
                {{currentSlide + 1}}/3
            </div>
            <div class="col-4 text-right">
                <navigation-button v-if="currentSlide < 1 || currentSlide > 2" mode="next" :allow-press="allowNext" @button-clicked="currentSlide++"></navigation-button>
                <navigation-button mode="save" v-if="currentSlide == 2" :allow-press="allowNext" @button-clicked="saveConfig()"></navigation-button>
            </div>
        </div>

    </div>
</template>

<script>
    import axios from 'axios'
    import Bus from '@/Bus.js';
    //import { mapState } from 'vuex';
    // import * as general from '../../scripts/General.js'

    import Questionnaire from "@/private/components/UI-elements/Questionnaire";
    import NavigationButton from "@/private/components/UI-elements/NavigationButton.vue";
    import LocaleSwitcher from "@/public/components/LocaleSwitcher.vue";
    //
    export default {
        name: 'AccountConfig',
        data: function () {

            return {
                currentSlide: 0,
                localConfig: {},
            }

        },
        components: {
            Questionnaire,
            NavigationButton,
            LocaleSwitcher
        },
        props: {

        },
        beforeMount: function () {
            this.localConfig = JSON.parse(JSON.stringify(this.config))
            this.localConfig.blnToleranceDirty = true
            this.localConfig.blnSettingsDirty = true
        },
        mounted: function () {

        },
        methods: {
            //navSlide: function (val) {
            //    this.currentSlide = this.currentSlide + val;
            //}
            saveConfig: function () {
                //Do not show again next time
				this.localConfig.hospitalPreferences.showStartModal = false

                //Post new config to server
                axios.post('/dashboard/saveConfig', this.localConfig, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                    .then((response) => {

                        if (response.status == '200') {

                            //Update state
                            this.config = this.localConfig

                            //Close modal
                            Bus.$emit('close-modal');
                        }

                    })
                    .catch(function (error) {
                        alert(error);
                    }
                    );
            }
        },
        computed: {
            config: {
                get: function () {
                    return this.$store.state.config
                },
                set: function (newValue) {
                    this.$store.commit('SET_config', newValue)
                },
            },
			allowNext: function () {
                if (this.currentSlide == 0) {
                    //always allow advacing
                    return true
                } else if (this.currentSlide == 1) {
                    //Check if initial status is filled out

					if (this.localConfig.hospitalPreferences.initialStatus != 1 && this.localConfig.hospitalPreferences.initialStatus != 3) {
                        return false
                    }

                    return true
                } else if (this.currentSlide == 2) {
                    //check if tolerance is configured

					if (this.localConfig.tolerance.limFasteners < 1 || this.localConfig.tolerance.limHygiene < 1 || this.localConfig.tolerance.limProtection < 1) {
                        return false
					}

					return true
				}

				return true
			}
        },
        watch: {

        }
    }
</script>